module.exports = __webpack_public_path__ + "img/advertising_support.bbb898ba.png";